export const AUTHENTICATED_HOME_PATH = '/tabs/home';
export const ONBOARDING_PATH = '/register';

export const normalizePostLoginTarget = targetPath => {
  if (targetPath === '/home') return AUTHENTICATED_HOME_PATH;
  if (targetPath?.path === '/home') {
    return { ...targetPath, path: AUTHENTICATED_HOME_PATH };
  }
  return targetPath;
};

export const resolvePostGateNavigation = ({
  hasRegistered,
  onboardingCompleteStatus,
  pendingDeepLinkRoute = null,
  fallbackTarget = AUTHENTICATED_HOME_PATH,
}) => {
  if (hasRegistered !== onboardingCompleteStatus) {
    return {
      target: ONBOARDING_PATH,
      shouldConsumePendingDeepLink: false,
    };
  }

  if (pendingDeepLinkRoute) {
    return {
      target: pendingDeepLinkRoute,
      shouldConsumePendingDeepLink: true,
    };
  }

  return {
    target: fallbackTarget,
    shouldConsumePendingDeepLink: false,
  };
};

export const replaceWithRootNavigation = async (vueRouter, ionRouter, targetPath) => {
  const normalizedTargetPath = normalizePostLoginTarget(targetPath);

  if (ionRouter?.navigate) {
    try {
      await ionRouter.navigate(normalizedTargetPath, 'root', 'replace');
      return;
    } catch (error) {
      console.warn('[Navigation] Ionic root replace failed, falling back to Vue Router:', error);
    }
  }

  await vueRouter.replace(normalizedTargetPath);
};
